var map = {
	"./EditCollect": 10004,
	"./EditCollect/": 10004,
	"./EditCollect/BasicFields/NumberField": 23553,
	"./EditCollect/BasicFields/NumberField.jsx": 23553,
	"./EditCollect/BasicFields/PictureField": 48288,
	"./EditCollect/BasicFields/PictureField.jsx": 48288,
	"./EditCollect/BasicFields/SelectField": 77340,
	"./EditCollect/BasicFields/SelectField.jsx": 77340,
	"./EditCollect/BasicFields/SelectUserGroupField": 97692,
	"./EditCollect/BasicFields/SelectUserGroupField.jsx": 97692,
	"./EditCollect/BasicFields/TextAreaField": 9482,
	"./EditCollect/BasicFields/TextAreaField.jsx": 9482,
	"./EditCollect/BasicFields/TextField": 20503,
	"./EditCollect/BasicFields/TextField.jsx": 20503,
	"./EditCollect/CollectForm": 42564,
	"./EditCollect/CollectForm.jsx": 42564,
	"./EditCollect/ContentFields/Description": 64827,
	"./EditCollect/ContentFields/Description.jsx": 64827,
	"./EditCollect/ContentFields/Picture": 62307,
	"./EditCollect/ContentFields/Picture.jsx": 62307,
	"./EditCollect/ContentFields/Title": 48327,
	"./EditCollect/ContentFields/Title.jsx": 48327,
	"./EditCollect/Loader": 78445,
	"./EditCollect/Loader.jsx": 78445,
	"./EditCollect/QuestionFields/Comment": 61787,
	"./EditCollect/QuestionFields/Comment.jsx": 61787,
	"./EditCollect/QuestionFields/DateTime": 80421,
	"./EditCollect/QuestionFields/DateTime.jsx": 80421,
	"./EditCollect/QuestionFields/Grade": 76873,
	"./EditCollect/QuestionFields/Grade.jsx": 76873,
	"./EditCollect/QuestionFields/GradeOption": 46338,
	"./EditCollect/QuestionFields/GradeOption.jsx": 46338,
	"./EditCollect/QuestionFields/Numeric": 47813,
	"./EditCollect/QuestionFields/Numeric.jsx": 47813,
	"./EditCollect/QuestionFields/Photos": 94125,
	"./EditCollect/QuestionFields/Photos.jsx": 94125,
	"./EditCollect/QuestionFields/Selection": 16626,
	"./EditCollect/QuestionFields/Selection.jsx": 16626,
	"./EditCollect/QuestionFields/SelectionOption": 11649,
	"./EditCollect/QuestionFields/SelectionOption.jsx": 11649,
	"./EditCollect/QuestionFields/Signature": 31746,
	"./EditCollect/QuestionFields/Signature.jsx": 31746,
	"./EditCollect/QuestionFields/Variable": 43490,
	"./EditCollect/QuestionFields/Variable.jsx": 43490,
	"./EditCollect/SectionField": 29857,
	"./EditCollect/SectionField.jsx": 29857,
	"./EditCollect/index": 10004,
	"./EditCollect/index.jsx": 10004,
	"./PhotoGallery": 696,
	"./PhotoGallery/": 696,
	"./PhotoGallery/PhotoGallerySection": 36927,
	"./PhotoGallery/PhotoGallerySection.jsx": 36927,
	"./PhotoGallery/index": 696,
	"./PhotoGallery/index.jsx": 696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86900;